import { Button, Grid, Table, TableBody, TableCell, TableHead, TableRow, TextField } from '@mui/material';
import _ from 'lodash';
import React, { } from 'react';
import { useSelector } from 'react-redux';
import NumberFormatCustom from '../../../NumberFormatCustom/NumberFormatCustom';
import PortModel from '../../../PortSelector/models/PortModel';
import PortSelector from '../../../PortSelector/PortSelector';
import { portSelectorSelector } from '../../../PortSelector/reducers/PortSelectorReducer';
import SupportSheetDemDesAtPortModel from './models/SupportSheetDemDesAtPortModel';

interface SupportSheetDemDesAtPortProp {
    items: SupportSheetDemDesAtPortModel[],
    className?: string,
    onChange?: (selectedItems: SupportSheetDemDesAtPortModel[]) => void,
}


export const getDefaultDemDesAtPorts = () => {
    return [{
        index: 0,
        portId: 0,
        chtrsAmount: 0,
        ownerAmount: 0
    } as SupportSheetDemDesAtPortModel,
    {
        index: 1,
        portId: 0,
        chtrsAmount: 0,
        ownerAmount: 0
    } as SupportSheetDemDesAtPortModel
    ];
}

const SupportSheetDemDesAtPort: React.FunctionComponent<SupportSheetDemDesAtPortProp> = (props) => {
    let portSelectorData = useSelector(portSelectorSelector);

    const getPortById = (portId: number) => {
        let selectedPort = _.find(portSelectorData.ports, (port) => {
            return port.id === portId;
        });

        if (selectedPort) {
            return selectedPort;
        }

        return null;
    }

    return (
        <>
            <div>Dem/Des settlement</div>
            <div>
                <Table className="datatable">
                    <TableHead>
                        <TableRow className="datatable-head">
                            <TableCell>Port</TableCell>
                            <TableCell colSpan={2}>Amount</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            props.items.map((item: SupportSheetDemDesAtPortModel, index: number) => (
                                <TableRow>
                                    <TableCell className='support-sheet-invoice-cell support-sheet-dem-des-port'>
                                        <PortSelector
                                            onPortChange={(value: PortModel | null) => {
                                                if (props.onChange) {
                                                    let items = [...props.items];
                                                    items[index].portId = value ? (value as PortModel).id : 0;
                                                    props.onChange(items);
                                                }
                                            }}
                                            portLabel='Port'
                                            areaLabel='Area'
                                            hideArea={true}
                                            isAreaDisabled={true}
                                            portValue={getPortById(item.portId)}
                                            isAreaRelatedToPort={false}
                                        >
                                        </PortSelector>
                                    </TableCell>
                                    <TableCell className='support-sheet-invoice-cell'>
                                        <TextField
                                            label="Chtrs amount"
                                            fullWidth
                                            value={item.chtrsAmount}
                                            InputProps={{
                                                inputComponent: NumberFormatCustom as any,
                                            }}
                                            onChange={(event) => {
                                                if (props.onChange) {
                                                    if (props.onChange) {
                                                        let items = [...props.items];
                                                        items[index].chtrsAmount = parseFloat(event.target.value);
                                                        props.onChange(items);
                                                    }
                                                }
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell className='support-sheet-invoice-cell'>
                                        <TextField
                                            label="Owners amount"
                                            fullWidth
                                            value={item.ownerAmount}
                                            InputProps={{
                                                inputComponent: NumberFormatCustom as any,
                                            }}
                                            onChange={(event) => {
                                                if (props.onChange) {
                                                    if (props.onChange) {
                                                        let items = [...props.items];
                                                        items[index].ownerAmount = parseFloat(event.target.value);
                                                        props.onChange(items);
                                                    }
                                                }
                                            }}
                                        />
                                    </TableCell>
                                    <TableCell>
                                        <Button
                                            className='table-action-button'
                                            onClick={() => {
                                                if (props.onChange) {
                                                    props.items.splice(index, 1);
                                                    props.onChange(props.items);
                                                }
                                            }}
                                            variant='text'
                                        >
                                            <i className="fa fa-times" aria-hidden="true"></i>
                                        </Button>
                                    </TableCell>
                                </TableRow>
                            ))
                        }
                    </TableBody>
                </Table>
            </div>
            <Button
                color="secondary"
                variant='outlined'
                onClick={() => {
                    let items = [...props.items, {
                        index: props.items.length,
                        portId: 0,
                        chtrsAmount: 0,
                        ownerAmount: 0
                    } as SupportSheetDemDesAtPortModel];

                    if (props.onChange) {
                        props.onChange(items);
                    }
                }}
            >Add more port</Button>
        </>
    )
};

export default SupportSheetDemDesAtPort;